// extracted by mini-css-extract-plugin
module.exports = {"stagesWrp":"stages_stagesWrp__3CIRw","stagesCon":"stages_stagesCon__3_imi","addNewWrp":"stages_addNewWrp__2xTTB","addNewCon":"stages_addNewCon__wVznL","icon":"stages_icon__HOYV5"};